//@ts-nocheck
/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-04 14:43:52
 */
import { getInstituteList, querSaveUserWatchTime } from "@root/common/service";
import { setDictionaries } from "@root/reducers/dictionaries";
import { store } from "@root/store/index";
interface InstitutePropsType {
  /**机构Id */
  id: number;
  /**机构名称*/
  name: string;
}
/**校验18位身份证号 */
export let _IDRe18 =
  /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
/**校验15位身份证号 */
export let _IDre15 =
  /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
/**校验密码 */
export let _testPassWord = /^(?![0-9]+$)(?![a-z]+$)[0-9A-Za-z]{6,20}$/;
/**
 * 校验身份证号码规则
 * @param idCard 身份证号码
 * @returns
 */
export function validatorIdCard(idCard: string) {
  return _IDre15.test(idCard) || _IDRe18.test(idCard);
}
/**
 * 校验密码
 * @param idCard 身份证号码
 * @returns
 */
export function validatorPassWord(passWord: string) {
  return _testPassWord.test(passWord);
}
/**
 * 用户角色映射
 */
export const userRoleMap = new Map([
  ["1", "超级管理员"],
  ["2", "普通角色"],
  ["10", "全国级"],
  ["11", "省级"],
  ["12", "县医院"],
  ["13", "支援医院"],
  ["14", "培训角色"],
  ["15", "市级"],
  ["16", "专家"],
  ["20", "编辑管理员"],
  ["21", "编辑"],
  ["22", "运营"],
]);
/**
 * 健康界地址
 */
export const healthcare = "https://nhc.cn-healthcare.com/";
/**
 * 处理对象返回str拼接
 * @param value
 * @returns string
 */
export function objectFormatStr(value: any) {
  let str = "";
  for (let key in value) {
    if (value[key]) {
      str += `&${key}=${value[key]}`;
    }
  }
  return str;
}
export const getIPs = (callback) => {
  var ip_dups = {};
  var RTCPeerConnection =
    window.RTCPeerConnection ||
    window.mozRTCPeerConnection ||
    window.webkitRTCPeerConnection;
  var mediaConstraints = {
    optional: [{ RtpDataChannels: true }],
  };
  // 这里就是需要的ICEServer了
  var servers = {
    iceServers: [
      { urls: "stun:stun.services.mozilla.com" },
      { urls: "stun:stun.l.google.com:19302" },
    ],
  };
  var pc = new RTCPeerConnection(servers, mediaConstraints);
  function handleCandidate(candidate) {
    var ip_regex =
      /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/;
    var hasIp = ip_regex.exec(candidate);
    if (hasIp) {
      var ip_addr = ip_regex.exec(candidate)[1];
      if (ip_dups[ip_addr] === undefined) callback(ip_addr);
      ip_dups[ip_addr] = true;
    }
  }
  // 网络协商的过程
  pc.onicecandidate = function (ice) {
    if (ice.candidate) {
      Candidate(ice.candidate.candidate);
    }
  };
  pc.createDataChannel("");
  //创建一个SDP(session description protocol)会话描述协议 是一个纯文本信息 包含了媒体和网络协商的信息
  pc.createOffer(
    function (result) {
      pc.setLocalDescription(
        result,
        function () {},
        function () {}
      );
    },
    function () {}
  );
  setTimeout(function () {
    var lines = pc.localDescription.sdp.split("\n");
    lines.forEach(function (line) {
      if (line.indexOf("a=candidate:") === 0) handleCandidate(line);
    });
  }, 1000);
};
/**
 * 处理Tree数据
 * @param data
 * @returns
 */
export const handleTreelData = (data: any) => {
  return data.map(
    (item: {
      key: number;
      parentId: number;
      title: string;
      children: any[];
    }) => {
      return {
        value: item.key || item.id,
        label: item.title || item.name,
        parentId: item.parentId,
        children: item.children ? handleTreelData(item.children) : [],
      };
    }
  );
};
/**
 * 获取机构
 */
export const queryInstituteList = async (instituteId: string) => {
  const { rows } = await getInstituteList(instituteId);
  const { directionaries } = store.getState();
  store.dispatch(
    setDictionaries({
      ...directionaries,
      instituteList: rows.map((item: InstitutePropsType) => {
        const { id, name } = item;
        return {
          id,
          name,
        };
      }),
    })
  );
};
/**
 *
 * @param data 广告
 * @param leaveTime 离开时间
 */
export const postLeaveAdvertisementTime = async (data, startTime) => {
  const {
    userInfo: { uumsId },
  } = store.getState();
  const handleData = data.map((item) => {
    return {
      sourceType: 1,
      sourceId: item.id,
      sourceName: item.title,
    };
  });
  const leaveTime = Math.floor(new Date().valueOf() / 1000 - startTime);
  data.length && querSaveUserWatchTime(handleData, leaveTime, uumsId);
};
/**
 *
 * @param data 广告
 * @param leaveTime 离开时间
 * @param sourcetype 1:图片(banner) 2：文章 3：课程
 * @param type 类型 1：停留 2点击
 */
export const postLeaveAdvertisementTimeMap = async (
  data,
  startTime,
  length,
  sourcetype = 2,
  operationType = 1
) => {
  const {
    userInfo: { uumsId },
  } = store.getState();
  const handleData = data.map((item) => {
    return {
      sourceType: sourcetype,
      sourceId: item.id,
      sourceName: item.title,
    };
  });
  const leaveTime = Math.floor(
    (new Date().valueOf() / 1000 - startTime) / length
  );
  data.length &&
    querSaveUserWatchTime(handleData, leaveTime, uumsId, operationType);
};
export function getBrowser() {
  // 获取浏览器 userAgent
  const ua = navigator.userAgent;
  const ucs = navigator.userAgent.toLowerCase();
  // 是否为 Opera
  const isOpera = ua.indexOf("Opera") > -1;
  // 返回结果
  if (isOpera) {
    return "Opera";
  }
  // 是否为 Edge
  const isEdge = ua.indexOf("Edg") > -1;
  // 返回结果
  if (isEdge) {
    return "Edge";
  }
  // 是否为 IE
  const isIE =
    ua.indexOf("compatible") > -1 && ua.indexOf("MSIE") > -1 && !isOpera;
  const isIE11 = ua.indexOf("Trident") > -1 && ua.indexOf("rv:11.0") > -1;
  // 返回结果
  if (isIE11) {
    return "IE11";
  } else if (isIE) {
    // 检测是否匹配
    const re = new RegExp("MSIE (\\d+\\.\\d+);");
    re.test(ua);
    // 获取版本
    const ver = parseFloat(RegExp["$1"]);
    // 返回结果
    if (ver === 7) {
      return "IE7";
    } else if (ver === 8) {
      return "IE8";
    } else if (ver === 9) {
      return "IE9";
    } else if (ver === 10) {
      return "IE10";
    } else {
      return "IE";
    }
  }
  // 是否为 Firefox
  const isFirefox = ua.indexOf("Firefox") > -1;
  // 返回结果
  if (isFirefox) {
    return "Firefox";
  }
  // 是否为 Safari
  const isSafari = ua.indexOf("Safari") > -1 && ua.indexOf("Chrome") == -1;
  // 返回结果
  if (isSafari) {
    return "Safari";
  }
  // 是否为 QQ
  const isQQ = ua.indexOf("QQBrowser") > -1;
  // 返回结果
  if (isQQ) {
    return "QQBrowser";
  }
  // 是否为企业微信浏览器
  const isWxWork = /wxwork/i.test(ucs);
  if (isWxWork) {
    return "WxWork";
  }
  // 是否为微信浏览器
  const isWx = ucs.indexOf("micromessenger") !== -1;
  if (isWx) {
    return "WeiXin";
  }
  // 是否为钉钉浏览器
  const isDD = ucs.indexOf("dingtalk") !== -1;
  if (isDD) {
    return "DingDing";
  }
  // 是否为搜狗浏览器
  const isSougo = ucs.indexOf("se 2.x") > -1;
  // 返回结果
  if (isSougo) {
    return "SouGo";
  }
  // 是否为2345浏览器
  const is2345Explorer = ua.includes("2345Explorer");
  // 返回结果
  if (is2345Explorer) {
    return "2345Explorer";
  }
  // 是否为 Chrome
  const isChrome =
    ua.indexOf("Chrome") > -1 &&
    ua.indexOf("Edg") === -1 &&
    ua.indexOf("QQBrowser") === -1 &&
    ua.indexOf("2345Explorer") === -1 &&
    ua.indexOf("WOW64") === -1;
  // 返回结果
  if (isChrome) {
    return "Chrome";
  }
  // 是否是360
  const is360 =
    ua.indexOf("Chrome") > -1 &&
    ua.indexOf("WOW64") > -1 &&
    ua.indexOf("QQBrowser") === -1;
  if (is360) {
    return "360";
  }
  // 都不是
  return "";
}
